var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.9255 0.400391C7.67746 0.400391 0.990295 7.08756 0.990295 15.3356C0.990295 22.789 6.45116 28.9668 13.5924 30.0916V19.6538H9.79847V15.3356H13.5924V12.045C13.5924 8.29892 15.8224 6.23318 19.2325 6.23318C20.8666 6.23318 22.5783 6.52444 22.5783 6.52444V10.1974H20.6903C18.8382 10.1974 18.2586 11.3505 18.2586 12.532V15.3326H22.3976L21.7359 19.6508H18.2586V30.0886C25.3999 28.9698 30.8607 22.7905 30.8607 15.3356C30.8607 7.08756 24.1736 0.400391 15.9255 0.400391Z","fill":"#9FD833"}));
}

Facebook.defaultProps = {"width":"31","height":"31","viewBox":"0 0 31 31","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
